import React, { useState } from "react";
import Chat from "../chat";
import styles from "./ChatWidget.module.scss";

export default function ChatWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);

  const [size, setSize] = useState({
    width: 400,
    height: 500
  });

  const startResize = e => {
    e.preventDefault();

    const startX = e.clientX;
    const startY = e.clientY;

    const startWidth = size.width;
    const startHeight = size.height;

    const handleMouseMove = e => {
      const newWidth = startWidth - (e.clientX - startX);
      const newHeight = startHeight - (e.clientY - startY);

      setSize({
        width: Math.max(300, newWidth),
        height: Math.max(350, newHeight)
      });
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  return (
    <>
      {!isOpen && (
        <div className={styles.chatBoxButton} onClick={() => setIsOpen(true)}>
          Ask Tracer (Beta)
        </div>
      )}

      {isOpen && (
        <div
          className={`${styles.chatContainer} ${
            isMinimized ? styles.minimized : ""
          }`}
          style={{
            width: size.width,
            height: isMinimized ? 50 : size.height
          }}
        >
          {!isMinimized && (
            <div className={styles.resizeHandle} onMouseDown={startResize} />
          )}

          <div className={styles.chatHeader}>
            <span>Ask Tracer (Beta)</span>

            <div className={styles.actions}>
              <button onClick={() => setIsMinimized(!isMinimized)}>
                {isMinimized ? "🔼" : "➖"}
              </button>

              <button
                onClick={() => {
                  setIsOpen(false);
                  setIsMinimized(false);
                }}
              >
                ✕
              </button>
            </div>
          </div>

          <div className={styles.chatBody}>
            <Chat />
          </div>
        </div>
      )}
    </>
  );
}
